<template>
  <a href="" class="button-menu" :class="{ 'is-active': active }">
    <span class="button-menu__icon">
      <font-awesome-icon :icon="icon" />
    </span>
    <span class="button-menu__text">{{ text }}</span>
  </a>
</template>

<script>
export default {
  name: 'button-menu',

  props: {
    active: { type: Boolean, default: false },
    icon: { type: String, default: 'angle-double-right' },
    text: { type: String, default: 'Inicio' }
  }
}
</script>
